import { AdminFetchWallets } from 'src/constants/actionTypes'
import type { FetchWalletsPayload, PartnerWallet } from 'src/interfaces/wallet'
import { resolveErrorMessage } from 'src/utils/sagaErrorMessage'
import { Action } from 'src/utils/reduxUtils'
import type { WalletState } from './types'

const getInitialState = (): WalletState => {
  return { wallets: [], loadedKey: null, requestedKey: null, loading: false, error: null }
}

export const walletReducer = (
  state: WalletState = getInitialState(),
  action: Action<unknown>,
): WalletState => {
  switch (action.type) {
    case AdminFetchWallets.type.REQUEST: {
      const requestedKey = String(
        Boolean((action.payload as FetchWalletsPayload | undefined)?.activeOnly),
      )
      const isSameKey = requestedKey === state.loadedKey

      return {
        ...state,
        wallets: isSameKey ? state.wallets : [],
        loadedKey: isSameKey ? state.loadedKey : null,
        requestedKey,
        loading: true,
        error: null,
      }
    }
    case AdminFetchWallets.type.SUCCESS:
      return {
        ...state,
        wallets: (action.payload as PartnerWallet[] | undefined) ?? [],
        loadedKey: state.requestedKey,
        loading: false,
        error: null,
      }
    case AdminFetchWallets.type.FAILED:
      return {
        ...state,
        loading: false,
        error: resolveErrorMessage(action.payload, 'Failed to load wallets'),
      }

    default:
      return state
  }
}
